module.exports = __webpack_public_path__ + "img/konfigurator-tooltip-spiegel-01.083d23e9.jpg";